<template>
  <div class="content">
    <div class="container">
      <el-form
        class="form_pad"
        ref="formPad"
        :inline="true"
        :model="listQuery"
      >
        <el-form-item :label="$t('statInfo.timeRange')">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            style="width: 302px"
            :range-separator="$t('statInfo.to')"
            :start-placeholder="$t('statInfo.startDate')"
            :end-placeholder="$t('statInfo.endDate')"
            value-format="yyyy-MM-dd"
            @change="querySearch"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('statInfo.templateName')">
          <el-select
            v-model="listQuery.template_id"
            clearable
            filterable
            style="width: 160px"
            :placeholder="$t('common.select')"
            @change="querySearch"
          >
            <el-option
              v-for="item in $com.templateList"
              :key="item.template_id"
              :label="$i18n.locale == 'zh'?item.name + '-' + item.template_id : item.en_name + '-' + item.template_id"
              :value="item.template_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.app')">
          <el-select
            v-model="listQuery.application_id"
            clearable
            filterable
            style="width: 160px"
            :placeholder="$t('common.select')"
            @change="appSelectChange"
          >
            <el-option
              :label="$t('common.all')"
              :value="0"
            />
            <el-option
              v-for="item in appList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.adZone')">
          <el-select
            v-model="listQuery.media_ad_slot"
            clearable
            filterable
            style="width: 160px"
            :placeholder="$t('common.select')"
            @change="querySearch"
          >
            <el-option
              v-for="item in adList"
              :key="item.id"
              :label="item.name+'【'+ item.ad_zone_id +'】'"
              :value="item.ad_zone_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.subDim')">
          <el-select
            v-model="listQuery.segment_dim"
            clearable
            filterable
            style="width: 160px"
            :placeholder="$t('common.select')"
            @change="querySearchDim"
          >
            <el-option
              v-for="item in segmentList"
              :key="item.value"
              :label="$i18n.locale == 'zh'?item.name : item.en_name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="form_pad">
        <p class="drawer_line clear_fix">
          {{$t('statInfo.trendChart')}}
          <el-button type="text" style="float: right" size="large" @click="chartFlag = !chartFlag">
            {{chartFlag? $t('statInfo.close') : $t('statInfo.open')}}
            <i :class="chartFlag? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </el-button>
        </p>
        <div v-show="chartFlag" style="width:100%;">
          <el-button-group class="btn_group" style="width:100%">
            <el-button type="text" 
              v-for="(item,index) in statsList" 
              :key="index"
              :class="activeStat == item.label?'active_class' : ''"
              plain
              size="large" 
              @click="handleCurrent(item.label, item.name)">
              {{item.name}}
            </el-button>
          </el-button-group>
        </div>
        <div v-show="chartFlag" style="width:100%;height:400px;text-align:center;line-height:400px" ref="chart" v-loading="listLoading">
          <div style="color: #909399">
            {{$t('statInfo.noData')}}
          </div>
        </div>
      </div>
      <div class="downLoad drawer_line clear_fix">
        <!-- <download-excel
            style="float:right"
            class = "export-excel-wrapper"
            :data = "json_data"
            :fields = "json_fields"
            :header="$t('statInfo.table')"
            :name ="$t('statInfo.table')+'.xls'"
            :fetch = "beforeFinish">
        </download-excel> -->
        {{$t('statInfo.summaryReport')}}
        <div class="btn_style" style="float:right">
          <span class="fred">
            {{$t('statInfo.downloadTip')}}
          </span>
          <el-button type="primary" size="mini" @click="exportExcel">
            <Icon name="export" class="svg-icon exportIcon"/>
            {{$t('statInfo.export')}}
          </el-button>
          <el-button type="primary" size="mini" :loading="streamExporting" @click="exportStreamCsv">
            <Icon v-if="!streamExporting" name="export" class="svg-icon exportIcon"/>
            {{$t('statInfo.exportStream')}}
          </el-button>
        </div>
      </div>
      <el-table
        ref="orderTable"
        class="table"
        :data="tableList"
        style="width: 100%;margin-top:12px;"
        v-loading="listLoading"
        >
        <el-table-column :label="$t('statInfo.date')" align="left">
          <template slot-scope="scope">{{ scope.row.summary | summaryFliter($i18n.locale)}}</template>
        </el-table-column>
        <el-table-column :label="tabletitle1" align="left" v-if="listQuery.segment_dim">
          <template slot-scope="scope">{{ scope.row.name}}</template>
        </el-table-column>
        <el-table-column :label="tabletitle2" align="left" v-if="listQuery.segment_dim == 'media_ad_slot'">
          <template slot-scope="scope">{{ scope.row.col}}</template>
        </el-table-column>
        <el-table-column :label="$t('statInfo.rawReq')" align="right">
          <template slot-scope="scope">{{ scope.row.raw_req | commafyFilter}}</template>
        </el-table-column>
        <el-table-column :label="$t('statInfo.bid')" align="right">
          <template slot-scope="scope">{{ scope.row.bid | commafyFilter}}</template>
        </el-table-column>
        <el-table-column :label="$t('statInfo.exposure')" align="right">
          <template slot-scope="scope">{{ scope.row.imp | commafyFilter}}</template>
        </el-table-column>
        <el-table-column :label="$t('statInfo.exposureRate')" align="right">
          <template slot-scope="scope">{{ scope.row.imp_rate }}</template>
        </el-table-column>
        <el-table-column :label="$t('statInfo.click')" align="right">
          <template slot-scope="scope">{{ scope.row.clk | commafyFilter}}</template>
        </el-table-column>
        <el-table-column :label="$t('statInfo.clickRate')" align="right">
          <template slot-scope="scope">{{ scope.row.click_rate }}</template>
        </el-table-column>
        <el-table-column :label="$t('statInfo.CPM')" align="right">
          <template slot-scope="scope">{{ scope.row.cpm_price }}</template>
        </el-table-column>
        <el-table-column :label="$t('statInfo.profit')" align="right">
          <template slot-scope="scope">{{ scope.row.media_price}}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        class="pagination"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next"
        :page-size="20"
        :current-page.sync="listQuery.page"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util';
import APIs from '@/api';
import echarts from 'echarts'
import LAY_EXCEL from 'lay-excel'
export default {
  data() {
    return {
      activeStat: 'req',
      activeStatName: '',
      listLoading: false,
      streamExporting: false,
      chartFlag: true,
      dateRange: [],
      total: 0,
      exchange_id: null,
      listQuery: {
        template_id: 0,
        start_date: '',
        end_date: '',
        current_label: '',
        application_id: 0,
        media_ad_slot: null,
        segment_dim: '',
        is_all: 0,
        page: 1,
        page_size: 20,
      },
      tableList: [],
      appList: [],
      adList: [],
      sourceList: [],
      segmentList: [
        {
          value: "template_id",
          name: "分模板名称",
          en_name: "sub template name"
        },
        {
          value: "application_id",
          name: "分应用",
          en_name: "sub application"
        },
        {
          value: "media_ad_slot",
          name: "分广告位",
          en_name: "sub ad space"
        },
      ],
      chartData: {},
      // json_fields: {
      //   日期时间: "summary",      
      //   下发: "req",
      //   曝光: "imp",
      //   曝光率: "imp_rate",
      //   点击: "clk",
      //   点击率: "click_rate",
      //   CPM: "cpm_price",
      //   预估收益: "media_price",
      // },
      json_data: [],
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 "
          }
        ]
      ],
      tabletitle1: "",
      tabletitle2: "",
    }
  },
  computed:{
    json_fields() {
      return {
        [this.$t('statInfo.date')]: "summary",     
        [this.tabletitle1]: "name",     
        [this.tabletitle2]: "col",  
        [this.$t('statInfo.rawReq')]: "raw_req",
        [this.$t('statInfo.bid')]: "bid",
        [this.$t('statInfo.exposure')]: "imp",
        [this.$t('statInfo.exposureRate')]: "imp_rate",
        [this.$t('statInfo.click')]: "clk",
        [this.$t('statInfo.clickRate')]: "click_rate",
        [this.$t('statInfo.CPM')]: "cpm_price",
        [this.$t('statInfo.profit')]: "media_price",
      }
    },
    statsList() {
      return [
        {
          label: "raw_req",
          name: this.$t('statInfo.rawReq')
        },
        {
          label: "bid",
          name: this.$t('statInfo.bid')
        },
        {
          label: "imp",
          name: this.$t('statInfo.exposure')
        },
        {
          label: "imp_rate",
          name: this.$t('statInfo.exposureRate')
        },
        {
          label: "clk",
          name: this.$t('statInfo.click')
        },
        {
          label: "click_rate",
          name: this.$t('statInfo.clickRate')
        },
        {
          label: "cpm_price",
          name: this.$t('statInfo.CPM')
        },
        {
          label: "media_price",
          name: this.$t('statInfo.profit')
        },
      ]
    }
  },
  filters: {
    commafyFilter(val) {
      return util.commafy(val)
    },
    summaryFliter(val, locale) {
      let str = ""
      if(val == "汇总") {
        if(locale == "zh") {
          str = "汇总"
        } else {
          str = "summary"
        }
      } else {
        str = val
      }
      return str
    },
  },
  watch: {
    '$i18n.locale'(newVal) {
      if(newVal == 'zh') {
        if(this.listQuery.segment_dim == 'template_id') {
          this.tabletitle1 = "模板"
        } else if(this.listQuery.segment_dim == 'application_id') {
          this.tabletitle1 = "应用"
        } else if(this.listQuery.segment_dim == 'media_ad_slot') {
          this.tabletitle1 = "广告位"
          this.tabletitle2 = "应用"
        } else {
          this.tabletitle1 = ""
        }
      } else {
        if(this.listQuery.segment_dim == 'template_id') {
          this.tabletitle1 = "template"
        } else if(this.listQuery.segment_dim == 'application_id') {
          this.tabletitle1 = "application"
        } else if(this.listQuery.segment_dim == 'media_ad_slot') {
          this.tabletitle1 = "adZone"
          this.tabletitle2 = "application"
        } else {
          this.tabletitle1 = ""
        }
      }
    }
  },
  created() {
    if(this.$i18n.locale == 'zh') {
      this.tabletitle1 = ''
      this.tabletitle2 = "应用"
    } else {
      this.tabletitle1 = ''
      this.tabletitle2 = "application"
    }
    // 初始化默认当天，模板全部
    this.dateRange[0] = util.getNowFormatDate()
    this.dateRange[1] = util.getNowFormatDate()
    this.listQuery.start_date = this.dateSplit(this.dateRange[0])
    this.listQuery.end_date = this.dateSplit(this.dateRange[1])
    this.getExchangeId()
    this.getApplist()
    this.getAdlist()
  },
  mounted() {
    this.$eventBus.$on("getLang",function(val){
    })
  },
  methods: {
    // 获取应用下拉列表
    getApplist() {
      this.__getData('getAppListAll', null, (res) => {
        this.appList = res        
      })
    },
    // 获取广告位下拉列表
    getAdlist() {
      this.__getData('getAdListAll', null, (res) => {
        this.adList = res
      })
    },
    getExchangeId() {
      this.__getData("getExchangeId", null, res => {
        this.exchange_id = res.id
        if(res.id !== 0) {
          this.handleCurrent('bid', this.$t('statInfo.bid'))
          }
      })
    },
    // getDimList() {
    //   this.__getData("dimList", null, res => {
    //     this.sourceList = res.template_info
    //   })
    // },
    getSumStatisticInfo() {
      if(this.exchange_id == 0) {
        return
      }
      this.listLoading = true
      this.listQuery.current_label = this.activeStat
      let params = util.filterParams(this.listQuery)
      this.__getData("getSumStatisticInfo", params, (res) => {
        this.listLoading = false
        if(res.code == 1) { 
          this.$message.error(res.msg);
        } else {
          this.chartData = res.data.chart
          this.tableList = res.data.table.data
          this.total = res.data.table.pageinfo.total_size
          // // 绘制图表
          this.handelInitCharts()
        }
      })
    },
    handleCurrent(val, name) {
      this.activeStat = val
      this.activeStatName = name
      this.getSumStatisticInfo()
    },
    querySearch() {
      if(this.dateRange.length > 0) {
        this.listQuery.start_date = this.dateSplit(this.dateRange[0])
        this.listQuery.end_date = this.dateSplit(this.dateRange[1])
      }
      this.getSumStatisticInfo()
    },
    appSelectChange() {
      this.listQuery.media_ad_slot = ""
      this.getAdlist()
      this.querySearch()
    },
    querySearchDim(val) {
      if(this.$i18n.locale == 'zh') {
        if(val == 'template_id') {
          this.tabletitle1 = "模板"
        } else if(val == 'application_id') {
          this.tabletitle1 = "应用"
        } else if(val == 'media_ad_slot') {
          this.tabletitle1 = "广告位"
          this.tabletitle2 = "应用"
        } else {
          this.tabletitle1 = ""
        }
      } else {
        if(val == 'template_id') {
          this.tabletitle1 = "template"
        } else if(val == 'application_id') {
          this.tabletitle1 = "application"
        } else if(val == 'media_ad_slot') {
          this.tabletitle1 = "adZone"
          this.tabletitle2 = "application"
        } else {
          this.tabletitle1 = ""
        }
      }
      this.querySearch()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getSumStatisticInfo()
    },
    handleSizeChange(val) {
      this.listQuery.page = 1
      this.listQuery.page_size = val
      this.getSumStatisticInfo()
    },
    // 日期处理
    dateSplit(val){
      let str = ""
      if(val.substring(8,10).length == 1) {
        str = '0' + val.substring(8,10)
      } else {
        str = val.substring(8,10)
      }
      return val.substring(0,4) + val.substring(5,7) + str
    },
    // 除去数字多余的零
    cutZero(old){
        //拷贝一份 返回去掉零的新串
        let newstr=old;
        //循环变量 小数部分长度
        var leng = old.length-old.indexOf(".")-1
        //判断是否有效数
        if(old.indexOf(".")>-1){
          //循环小数部分
          for(var i=leng;i>0;i--){
                //如果newstr末尾有0
                if(newstr.lastIndexOf("0")>-1 && newstr.substr(newstr.length-1,1)==0){
                    var k = newstr.lastIndexOf("0");
                    //如果小数点后只有一个0 去掉小数点
                    if(newstr.charAt(k-1)=="."){
                        return  newstr.substring(0,k-1);
                    }else{
                    //否则 去掉一个0
                        newstr=newstr.substring(0,k);
                    }
                }else{
                //如果末尾没有0
                    return newstr;
                }
            }
        }
        return old;
    },
    handelInitCharts() {
      let that = this
      let myChart = echarts.init(this.$refs.chart);
      let yname = ""
      let subStr = this.activeStat.substring(this.activeStat.length-5, this.activeStat.length)
      if(subStr == '_rate') {
        yname = "%"
      } else if (subStr == 'price') {
         yname = "元"
      }
        // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter(params){
            var res='<p>'+that.$t('statInfo.time') + '：'+params[0].name+'</p>' 
            for(var i=0;i<params.length;i++){
              res+='<p>'+params[i].marker + params[i].seriesName+'：'+ that.cutZero(params[i].data) +yname+'</p>'
            }
            return res
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.chartData.labels,
        },
        yAxis: {
          type: 'value',
          name: yname
        },
        legend: {
          data: [this.activeStatName],
          // data: [this.activeStatName, this.activeStatName+'同比'],
          right: 50,
          top: 20,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        series: [
          {
            name: this.activeStatName,
            type: 'line',
            smooth: true,
            data: this.chartData.current,
          },
          {
            name: this.activeStatName + '同比',
            type: 'line',
            smooth: true,
          },
        ]
      });
      window.onresize = function () {
        myChart.resize();
      }
    },
    // 导出列表
    exportExcel() {
      this.listQuery.current_label = this.activeStat
      this.listQuery.is_all = 1
      let params = util.filterParams(this.listQuery)
      this.__getData("getSumStatisticInfo", params, (res) => {
        let tableList = res.data.table.data
        this.exportData(tableList)
      })
    },
    // 流式导出列表：直接下载后端返回的 CSV 文件流
    // 不走 axios 封装，响应体是文件而非 JSON，会被响应拦截器解析失败
    async exportStreamCsv() {
      if (this.streamExporting) {
        return
      }
      this.streamExporting = true
      let params = util.filterParams({ ...this.listQuery, current_label: this.activeStat })
      try {
        const resp = await fetch(`${APIs.getStatsExportStream}?${new URLSearchParams(params).toString()}`, {
          method: 'GET',
          headers: {
            'Authorization': util.getCookie('token')
          },
          credentials: 'include',
        })
        // 后端出错时返回 HTTP 200 + JSON，只能按 Content-Type 判断成败
        const contentType = resp.headers.get('Content-Type') || ''
        if (contentType.indexOf('text/csv') === -1) {
          const res = await resp.json()
          this.$message.error(res.msg || this.$t('statInfo.exportStreamFail'))
          if (Number(res.code) === 2000) {
            this.$store.commit('$_removeStorage')
            this.$router.push({ path: '/login' })
          }
          return
        }
        const disposition = resp.headers.get('Content-Disposition') || ''
        const matched = disposition.match(/filename=([^;]+)/)
        const filename = matched ? matched[1].trim() : 'stats.csv'
        const blob = await resp.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error(this.$t('statInfo.exportStreamFail'))
      } finally {
        this.streamExporting = false
      }
    },
    exportData(list) {
    let arr = ['summary', 'name', 'raw_req', 'bid', 'imp', 'imp_rate', 'clk', 'click_rate', 'cpm_price', 'media_price']
    let data = [[this.$t('statInfo.date'), this.tabletitle1, this.$t('statInfo.rawReq'), this.$t('statInfo.bid'), this.$t('statInfo.exposure'), this.$t('statInfo.exposureRate'), this.$t('statInfo.click'), this.$t('statInfo.clickRate'), this.$t('statInfo.CPM'), this.$t('statInfo.profit')]]
    // 分广告位的时候导出数据加上应用列
    if(this.listQuery.segment_dim == 'media_ad_slot') {
      arr.splice(2, 0, "col")
      data[0].splice(2, 0, this.tabletitle2)
    }
    // 如果this.tabletitle1为空，则导出时去掉第二列
    if(this.tabletitle1 == "") {
      arr.splice(1, 1)
      data[0].splice(1, 1)
    }
    list.map(el => {
      let newArr = []
      arr.forEach(item => {
        newArr.push(el[item])
      })
      data.push(newArr)
    })
    LAY_EXCEL.setExportCellStyle(data, 'A1:J1', {
      s: {
        fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "d4e4f5" } },
        alignment: {
          horizontal: 'center',
          vertical: 'center'
        }
      }
    });
    LAY_EXCEL.exportExcel(data, '数据汇总列表.xlsx', 'xlsx',{
      extend: {
        '!cols': LAY_EXCEL.makeColConfig({
          'A': 100,
          'B': 100,
          'C': 120,
          'D': 120,
          'E': 100,
          'F': 100,
          'G': 120,
          'H': 120,
          'I': 120,
          'J': 120,
          'K': 120,
        }),
      }
    })
  }
    // beforeFinish() {
    //   this.listQuery.current_label = this.activeStat
    //   this.listQuery.is_all = 1
    //   let params = util.filterParams( this.listQuery)
    //   let list = []
    //   this.__getData("getSumStatisticInfo", params, (res) => {
    //     let downList = res.table.data
    //     for(var i = 0; i <= downList.length; i++) {
    //       let obj = new Object()
    //       for(var v in downList[i]) {
    //         for(var k in this.json_fields) {
    //           if(this.json_fields[k] == v) {
    //             obj[""+v+""] = downList[i][""+v+""]
    //           }
    //         }
    //       }
    //       list.push(obj)
    //     }
    //   })
    //   return list
    // },
  }
}
</script>
<style  lang="scss" scoped>
.exportIcon {
  width: 14px;
  height: 14px;
}
.btn_group .el-button {
  border: none!important;
  margin: 0 15px;
  color: rgba(0,0,0,0.85)!important;
  border-radius: 0!important;
  box-sizing: border-box;
  border-bottom: 2px solid transparent!important;
}
.btn_group  .active_class{
  color: #3361FF!important;
  border-bottom: 2px solid #3361FF!important;
}
.btn_group {
  display: flex;
  justify-content: center;
}
.downLoad {
  padding-top: 10px; 
}
</style>